export default __webpack_public_path__ + "static/media/banner-page-cooperative-banks-mobile.03f67315.png";